// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Importar jQuery primero
import $ from 'jquery';
// Hacerlo global para que los plugins y las vistas lo vean
window.$ = window.jQuery = $;
// global.$ = jQuery;

// Ahora importar los que dependen de jQuery
import "datatables.net-bs4"

Rails.start()
ActiveStorage.start()

import "../vendor/onmount"
import '../vendor/form-toggle'
import '../components/ckeditor/textinput';
import '../components/ckeditor/templateinput';
// Nota: Solo importa login si es necesario en todo el sitio, 
// si no, se suele dejar en su propio pack.
import '../packs/login';
import '../notifications';